import React, { useEffect } from 'react';

declare global {
    interface Window {
        viewFeedsScript?: () => void; // Optional chaining for better type safety
    }
}

export function ViewFeed() {
    useEffect(() => {
        const cssUrl = '/css/viewFeedStyles.css';
        const jsUrl = '/js/viewFeedScript.js';

        // Create and append CSS link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        document.head.appendChild(link);

        // Load the script
        const script = loadScript(jsUrl);

        // Cleanup function to remove the elements on unmount
        return () => {
            document.head.removeChild(link);
            if (script) {
                script.onload = null; // Prevent memory leaks
                script.onerror = null;
                document.head.removeChild(script);
            }
        };
    }, []);

    const loadScript = (src: string) => {
        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        script.type = 'module';

        // Append script and handle load/error events
        script.onload = () => {
            console.log('Script loaded successfully.');
            if (window.viewFeedsScript) {
                window.viewFeedsScript();
            } else {
                console.error('Function viewFeedsScript is not defined.');
            }
        };

        script.onerror = () => {
            console.error('Error loading script.');
        };

        document.head.appendChild(script);
        return script; // Return script element for cleanup
    };

    return <div className='feedViewer'></div>;
}
